import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { MenuRadioGroupContext } from '#pplx/frontend/aether/components/internal/menu/MenuRadioGroupContext.js';
import { DropdownMenuPrimitive } from '#pplx/frontend/aether/primitives/DropdownMenuPrimitive/index.js';
import { useMemo } from 'react';
/**
 * A radio group component for use within menus to provide mutually-exclusive
 * selection behavior for menu radio items.
 *
 * @example
 * ```tsx
 * <Menu.RadioGroup value={selectedMode} onValueChange={setSelectedMode}>
 *   <Menu.RadioItem value="search">Search Mode</Menu.RadioItem>
 *   <Menu.RadioItem value="focus">Focus Mode</Menu.RadioItem>
 * </Menu.RadioGroup>
 * ```
 */
export function MenuRadioGroup({ value, onValueChange, children, closeOnSelect = false, }) {
    const { isMobileStyle } = useAetherContext();
    const contextValue = useMemo(() => ({
        value,
        onValueChange,
        closeOnSelect,
    }), [closeOnSelect, onValueChange, value]);
    // Desktop: Use Radix RadioGroup primitive with context for closeOnSelect
    if (!isMobileStyle) {
        return (_jsx(MenuRadioGroupContext.Provider, { value: contextValue, children: _jsx(DropdownMenuPrimitive.RadioGroup, { value: value, onValueChange: onValueChange, children: children }) }));
    }
    // Mobile: Use custom context provider (Menu renders as dialog, not Radix Menu)
    return (_jsx(MenuRadioGroupContext.Provider, { value: contextValue, children: children }));
}
//# sourceMappingURL=MenuRadioGroup.js.map